import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Button } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import { useAnchor } from 'shared/hooks/utils';
import { ResponsiveIcon } from '../../../icon/responsive';
import { RenamePanelDialog } from '../../panel/custom/rename-dialog';
import { WrapButton } from '../../../buttons/wrap';
import { useDeviceUISettingsControl } from 'console/shared/contexts/device-ui-settings/control';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
const available = false;
export const PanelsActions = memo(function PanelsActions() {
    const [anchorEl, onOpenDialog, onCloseDialog] = useAnchor();
    const { is_panels_wrapped, togglePanelsWrap } = useDeviceUISettingsControl();
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { display: "grid", gridAutoFlow: "column", justifyItems: "center", width: "100%", children: [isSmallUI() && (_jsx(WrapButton, { is_wrapped: is_panels_wrapped, onClick: togglePanelsWrap, word: "\u0440\u0430\u0437\u0434\u0435\u043B\u044B" })), available && (_jsx(Button, { onClick: onOpenDialog, startIcon: _jsx(ResponsiveIcon, { fontSize: "1.5em", Icon: AddRounded }), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0440\u0430\u0437\u0434\u0435\u043B" }))] }), _jsx(RenamePanelDialog, { open: !!anchorEl, onClose: onCloseDialog })] }));
});
